import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import MarketingModelosWhatsappEditorPage from '@/pages/dashboard/marketing-modelos-whatsapp-editor-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

const modelosWhatsappNovoSearchSchema = z.object({
  /** `livre` = mensagem aberta; `meta` = template oficial (WhatsApp Meta Cloud) */
  tipo: z.enum(['livre', 'meta']).optional(),
})

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/novo',
)({
  validateSearch: modelosWhatsappNovoSearchSchema,
  component: function MarketingModelosWhatsappNovoRoute() {
    const { dashboardId } = Route.useParams()
    const { tipo } = Route.useSearch()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingModelosWhatsappEditorPage
          mode="create"
          initialDeliveryTipo={tipo}
        />
      </RequireModule>
    )
  },
})
